import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';

export const Header = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const isActive = (path) => location.pathname === path;
  
  const links = [
    { path: '/', label: 'Home' },
    { path: '/how-i-work', label: 'How I work' },
    { path: '/case-studies', label: 'Case studies' },
    { path: '/background', label: 'Background' },
    { path: '/contact', label: 'Contact' }
  ];
  
  return (
    <header className="sticky top-0 z-50 bg-[#0a0a0a]/95 backdrop-blur-sm border-b border-[#888888]/20">
      <nav className="container mx-auto px-6 py-6 max-w-6xl">
        <div className="flex items-center justify-between">
          <Link to="/" className="text-xl font-bold text-[#F5F5F5] hover:text-[#E85D04] transition-colors">
            Bryan Adham Chew
          </Link>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex gap-8">
            {links.map(link => (
              <Link 
                key={link.path}
                to={link.path} 
                className={`text-sm font-medium transition-colors ${
                  isActive(link.path) ? 'text-[#E85D04]' : 'text-[#F5F5F5] hover:text-[#E85D04]'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
          
          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-[#F5F5F5] hover:text-[#E85D04] transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
        
        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-6 pb-4 space-y-4">
            {links.map(link => (
              <Link 
                key={link.path}
                to={link.path} 
                className={`block text-base font-medium transition-colors ${
                  isActive(link.path) ? 'text-[#E85D04]' : 'text-[#F5F5F5] hover:text-[#E85D04]'
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
          </div>
        )}
      </nav>
    </header>
  );
};